import React from 'react'
import { preventBubblingEvent } from '@mote/helpers/browser'
import { KeyboardKey, REACTION_EMOJIS } from '@mote/helpers/constants'
import { useReactionsContext } from '@mote/recipes'
import { Block } from '@mote/ui'
import styled, { css, th } from '@xstyled/styled-components'
import { Emoji } from '../../shared/components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'
import { moteCardFluidDimensionsAdjuster } from './fluidSizing'

export function MoteCardRichEmojiPicker() {
  const reactions = useReactionsContext()
  const { playerDimensions } = useMotePlayer()

  function handleEmojiSelection(reaction, event) {
    preventBubblingEvent(event)
    reactions.react(reaction)
  }

  return (
    <Root
      layout='horizontal'
      margin={`${moteCardFluidDimensionsAdjuster(
        18,
        7,
        playerDimensions?.width
      )}px 0 0 0`}
    >
      {REACTION_EMOJIS.map(({ emoji, label, value }) => (
        <StyledEmoji
          key={value}
          label={label}
          onClick={event => {
            handleEmojiSelection(value, event)
          }}
          onKeyDown={event => {
            if (
              [KeyboardKey.Space, KeyboardKey.Enter].includes(event.keyCode)
            ) {
              handleEmojiSelection(value, event)
            }
          }}
          selected={reactions.isEnabled(value)}
          emojiSize={moteCardFluidDimensionsAdjuster(
            48,
            42,
            playerDimensions?.width
          )}
          fontSize={moteCardFluidDimensionsAdjuster(
            24,
            24,
            playerDimensions?.width
          )}
          isInteractive
        >
          {emoji}
        </StyledEmoji>
      ))}
    </Root>
  )
}

const Root = styled(Block)``

const StyledEmoji = styled(Emoji)`
  &:hover,
  &:focus {
    background: ${th.color('whiteAlpha.300')};
  }

  ${({ selected }) =>
    selected &&
    css`
      background: ${th.color('white')};

      span.emoji {
        transform: scale(1.2) !important;
      }
    `};
`
